import * as React from 'react';
import SelectionControl, {SelectionControlPropsGetters} from '../SelectionControl';
import GhostInput from '../GhostInput';
import CheckboxWrapper from './private/CheckboxWrapper';
import CheckboxEffect from './private/CheckboxEffect';
import CheckboxVisual from './private/CheckboxVisual';
import CheckboxLabel from './private/CheckboxLabel';
import {CheckboxProps, CheckboxState} from './types';

export default class Checkbox extends React.Component<CheckboxProps, CheckboxState> {
  private _input: HTMLInputElement | null;

  constructor(props: CheckboxProps) {
    super(props);
    this.state = {
      effectIn: false
    };
  }

  public componentDidMount() {
    this.indeterminate = Boolean(this.props.indeterminate);
  }

  public componentWillReceiveProps(nextProps: CheckboxProps) {
    if (nextProps.indeterminate !== this.props.indeterminate) {
      this.indeterminate = Boolean(nextProps.indeterminate);
    }
  }

  public render() {
    return (
      <SelectionControl {...this.props} inputType="checkbox" onChange={this._handleChange} inputRef={this._setInput}>
        {({getWrapperProps, getInputProps, getStateProps}: SelectionControlPropsGetters) => {
          const {ref, ...restInputProps} = getInputProps();

          return (
            <CheckboxWrapper {...getWrapperProps()} {...getStateProps()}>
              <GhostInput innerRef={ref} {...restInputProps} />
              <CheckboxEffect checked={this.state.effectIn}>
                <CheckboxVisual {...getStateProps()} indeterminate={this.props.indeterminate} />
              </CheckboxEffect>
              <CheckboxLabel>{this.props.label}</CheckboxLabel>
            </CheckboxWrapper>
          );
        }}
      </SelectionControl>
    );
  }

  public get checked() {
    return this._input!.checked;
  }

  public set indeterminate(value: boolean) {
    this._input!.indeterminate = Boolean(value);
  }

  public focus() {
    this._input!.focus();
  }

  public blur() {
    this._input!.blur();
  }

  private _setInput = (node: HTMLInputElement | null) => {
    this._input = node;
  };

  private _handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({effectIn: event.target.checked});

    if (typeof this.props.onChange === 'function') {
      this.props.onChange(event);
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/Checkbox/Checkbox.tsx